import React, { useState, useEffect, useRef, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../css/Home.css";
import ChatPage from "./ChatPage";
import { useLocation, useOutletContext } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setIsChatPage } from "../redux/sessionSlice";
import { togglePrivacyMode } from "../redux/privacySlice";
import api from "../api";
import DisclaimerPopup from "../auth/DisclaimerPopup";
import AccessModePopup from "../components/AccessModePopup";
import {
  showErrorToast,
  showInfoToast,
  showSuccessToast,
} from "../utils/toastUtils";
//import warningIcon from "../assets/UserIcons/FileIcon.svg";
import { TOAST_MESSAGES } from "../utils/toastMessages";
import {
  setSelectedMenu,
  resetSidebarState,
  setRefreshSidebar,
} from "../redux/sidebarSlice";
import { branding } from "../utils/branding";

// Icons
import refreshIcon from "../assets/UserIcons/RefereshPrompt.svg";
import send from "../assets/UserIcons/SendChatIcon.svg";
import fileIcon from "../assets/UserIcons/FileIcon.svg";
import crossIcon from "../assets/UserIcons/Cancel.svg";
import pdfIcon from "../assets/icons/pdf.png";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import galleryIcon from "../assets/icons/galleryIcons.png";
import codeIcon from "../assets/icons/codeIcon.png";
import phraseIcon from "../assets/icons/pharseIcons.png";
import presentationIcon from "../assets/icons/presentationIcons.png";
import translationIcon from "../assets/icons/translationIcon.png";
import visualizationIcon from "../assets/icons/visualisationIcon.png";
import videoIcon from "../assets/icons/videoIcon.png";
import { truncate, validateFileName } from "../utils/validateFileName";
import reloadIcon from "../assets/UserIcons/Reload.svg";
import UploadDocumentModal from "./UploadDocumentModal";

function Home() {
  const { selectedModel, selectedMode } = useSelector((state) => state.model);
  const location = useLocation();
  const [input, setInput] = useState("");
  const [startChat, setStartChat] = useState(false);
  const [userMessage, setUserMessage] = useState("");
  const [sessionId, setSessionId] = useState(null);
  const [userName, setUserName] = useState("");
  const [refreshToggle, setRefreshToggle] = useState(false);
  const [fade, setFade] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 575);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [profilePicUrl, setProfilePicUrl] = useState("");

  const [activeButton, setActiveButton] = useState(""); // store "attach", "read", "mic", "search"
  // const [isSearchActive, setIsSearchActive] = useState(true);

  // Shows Pop Ups
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [showAccessMode, setShowAccessMode] = useState(false);

  const [showUploadModal, setShowUploadModal] = useState(false);
  const [uploadMode, setUploadMode] = useState("Personal");
  const [pendingUploadFiles, setPendingUploadFiles] = useState([]);
  const [folderItems, setFolderItems] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState({
    id: null,
    name: "Root",
  });

  const [uploadedInfo, setUploadedInfo] = useState({
    count: 0,
    type: "file",
  });

  const [attachedFiles, setAttachedFiles] = useState([]);
  const fileInputRef = useRef(null);
  const [filesUploaded, setFilesUploaded] = useState(false); // track upload completion
  const [micOpen, setMicOpen] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [tempTranscript, setTempTranscript] = useState(""); // NEW
  const [interimTranscript, setInterimTranscript] = useState(""); // live speech preview
  const recognitionRef = useRef(null);
  // State to track if reading is in progress
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [filesToSendForChat, setFilesToSendForChat] = useState([]);
  const [errorModal, setErrorModal] = useState({ show: false, message: "" });
  const [prompts, setPrompts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isFocused, setIsFocused] = useState(false);
  const isFullPrivacy = useSelector((state) => state.privacy.isFullPrivacy);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const [isProcessingSTT, setIsProcessingSTT] = useState(false);
  const [showResponsesModal, setShowResponsesModal] = useState(false);
  const [showInfoTooltip, setShowInfoTooltip] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  const hasEmailExtractFiles = useMemo(() => {
    const getExt = (name) => name?.split(".").pop()?.toLowerCase();
    return attachedFiles.some((f) => {
      const ext = getExt(f?.file?.name);
      return ext === "zip" || ext === "msg";
    });
  }, [attachedFiles]);

  useEffect(() => {
    if (!hasEmailExtractFiles) return;
    if (!input) return;
    setInput("");
    const textarea = document.querySelector(".input-textarea");
    if (textarea) {
      textarea.style.height = "40px";
      textarea.style.overflowY = "hidden";
    }
  }, [hasEmailExtractFiles, input]);

  const {
    isSearchActive,
    isKnowledgeSearchActive,
    uploadedDocNames,
    setUploadedDocNames,
    uploadedDocumentIds,
    setUploadedDocumentIds,
    aiPreferences,
    setAiPreferences,
    resetAiPreferences,
    DEFAULT_AI_PREFERENCES,
  } = useOutletContext();

  // const [duplicateModal, setDuplicateModal] = useState({
  //   show: false,
  //   duplicates: [],
  // });

  //VKD112  Added Name from local storage to show in home page after login

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser?.user_name) {
      setUserName(storedUser.user_name);
    }
  }, []);

  //VKD112  Ended Name from local storage to show in home page after login

  const handleMenuClick = (label) => {
    dispatch(setSelectedMenu(label));
  };

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

      const mediaRecorder = new MediaRecorder(stream, {
        mimeType: "audio/webm",
      });

      mediaRecorderRef.current = mediaRecorder;
      audioChunksRef.current = [];

      setIsRecording(true);
      setInterimTranscript("");
      setTempTranscript("");

      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      };

      mediaRecorder.start();
    } catch (err) {
      console.error("Mic error:", err);
      showErrorToast("Microphone access denied");
    }
  };

  const stopRecording = async () => {
    setIsRecording(false);

    const recorder = mediaRecorderRef.current;
    if (!recorder) return;

    recorder.stop();

    recorder.onstop = async () => {
      const audioBlob = new Blob(audioChunksRef.current, {
        type: "audio/webm",
      });

      const formData = new FormData();
      formData.append("file", audioBlob, "audio.webm");

      try {
        // 🔄 START PROCESSING
        setIsProcessingSTT(true);
        setInterimTranscript("Processing...");

        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/chat/realtime-stt`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          },
        );

        if (!response.ok) {
          throw new Error("STT request failed");
        }

        const data = await response.json();
        const text = data?.transcription?.trim();

        if (text) {
          setInput((prev) => prev + text + " ");
        }
      } catch (err) {
        console.error("STT error:", err);
        showErrorToast("Speech recognition failed");
      } finally {
        // ✅ STOP PROCESSING
        setIsProcessingSTT(false);
        setMicOpen(false);
        setInterimTranscript("");
        setTempTranscript("");
        audioChunksRef.current = [];
        mediaRecorderRef.current = null;
      }
    };
  };

  const cancelRecording = () => {
    setIsRecording(false);

    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      mediaRecorderRef.current = null;
    }

    audioChunksRef.current = [];
    setMicOpen(false);
    setInterimTranscript("");
    setTempTranscript("");
  };

  // // Start recording
  // const startRecording = () => {
  //   if (
  //     !("webkitSpeechRecognition" in window || "SpeechRecognition" in window)
  //   ) {
  //     showErrorToast("Your browser does not support speech recognition.");
  //     return;
  //   }

  //   setIsRecording(true);
  //   setTempTranscript(""); // Reset final transcript
  //   setInterimTranscript(""); // Reset live preview

  //   const SpeechRecognition =
  //     window.SpeechRecognition || window.webkitSpeechRecognition;
  //   const recognition = new SpeechRecognition();
  //   recognition.lang = "en-US";
  //   recognition.interimResults = true;
  //   recognition.continuous = true;

  //   let finalBuffer = "";

  //   recognition.onresult = (event) => {
  //     let interim = "";

  //     for (let i = event.resultIndex; i < event.results.length; i++) {
  //       const result = event.results[i];
  //       if (result.isFinal) {
  //         finalBuffer += result[0].transcript + " ";
  //       } else {
  //         interim += result[0].transcript;
  //       }
  //     }

  //     setTempTranscript(finalBuffer);
  //     setInterimTranscript(interim);
  //   };

  //   recognition.onerror = (event) => {
  //     console.error("Speech recognition error:", event.error);
  //   };

  //   recognitionRef.current = recognition;
  //   recognition.start();
  // };

  // // Stop recording and insert final transcript into input
  // const stopRecording = () => {
  //   setIsRecording(false);

  //   if (recognitionRef.current) {
  //     recognitionRef.current.stop();
  //     recognitionRef.current = null;
  //   }

  //   // Insert final transcript as plain text with punctuation
  //   setInput((prev) => prev + tempTranscript.trim() + " ");
  //   setMicOpen(false);
  //   setTempTranscript("");
  //   setInterimTranscript("");
  // };

  // // Cancel recording and discard
  // const cancelRecording = () => {
  //   setIsRecording(false);

  //   if (recognitionRef.current) {
  //     recognitionRef.current.stop();
  //     recognitionRef.current = null;
  //   }

  //   setMicOpen(false);
  //   setTempTranscript("");
  //   setInterimTranscript("");
  // };

  // Function to toggle reading aloud
  const toggleReadAloud = () => {
    if (!input) return;

    if (window.speechSynthesis.speaking) {
      // Stop current speech
      window.speechSynthesis.cancel();
      setIsSpeaking(false);
    } else {
      const utterance = new SpeechSynthesisUtterance(input);
      utterance.lang = "en-US";

      utterance.onstart = () => setIsSpeaking(true);
      utterance.onend = () => setIsSpeaking(false);
      utterance.onerror = () => setIsSpeaking(false);

      window.speechSynthesis.speak(utterance);
    }
  };

  // Trigger file input click
  const handleAttachClick = () => {
    fileInputRef.current?.click();
  };

  const MAX_ATTACHABLE_FILES = 20;

  // const handleDuplicateYes = async () => {
  //   const user = localStorage.getItem("user") || sessionStorage.getItem("user");

  //   const token =
  //     localStorage.getItem("access_token") ||
  //     sessionStorage.getItem("access_token");
  //   try {
  //     const res = await api.post(
  //       `${process.env.REACT_APP_API_URL}/files/allow-duplicate`,
  //       { duplicates: duplicateModal.duplicates, selectedMode, user },
  //       {
  //         headers: { Authorization: `Bearer ${token}` },
  //       }
  //     );

  //     showSuccessToast(
  //       `${res.data.count} duplicate files uploaded successfully`
  //     );

  //     setDuplicateModal({
  //       show: false,
  //       duplicates: [],
  //     });

  //     // Update UI: mark those files as done
  //     setAttachedFiles((prev) =>
  //       prev.map((f) =>
  //         duplicateModal.duplicates.find((x) => x.originalname === f.file.name)
  //           ? { ...f, status: "done" }
  //           : f
  //       )
  //     );
  //   } catch (err) {
  //     console.error("Duplicate upload failed:", err);
  //     showErrorToast("Failed to upload duplicate files");
  //   }
  // };

  // Allowed extensions
  const allowedExtensions = [
    "pdf",
    "docx",
    "txt",
    "doc",
    "pptx",
    "xlsx",
    "zip",
    "msg",
    "mp3",
    "wav",
    "aac",
    "flac",
    "mp4",
    "mov",
    "avi",
    "mkv",
    "flv",
    "png",
    "jpg",
    "jpeg",
    "gif",
    "bmp",
    "tiff",
  ];

  const filterSupportedFiles = (files) => {
    const supported = [];
    const unsupported = [];

    files.forEach((file) => {
      const ext = file.name.split(".").pop().toLowerCase();
      if (allowedExtensions.includes(ext)) {
        supported.push(file);
      } else {
        unsupported.push(file);
      }
    });

    return { supported, unsupported };
  };

  const formatToastMessage = (message) => {
    if (!message) return message;

    // Try to detect filenames with extensions
    const fileRegex = /([\w,\s-]+\.[A-Za-z]{2,6})/g;

    return message.replace(fileRegex, (match) => truncate(match));
  };

  // Handle file selection new
  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const { supported, unsupported } = filterSupportedFiles(files);

    if (unsupported.length > 0) {
      const names = unsupported.map((f) => f.name).join(", ");
      showErrorToast(`Unsupported file(s): ${names}`);
    }

    if (supported.length === 0) return;

    const currentFileCount = attachedFiles.length;
    if (currentFileCount >= MAX_ATTACHABLE_FILES) {
      showErrorToast(
        `You can upload a maximum of ${MAX_ATTACHABLE_FILES} files at a time.`,
      );
      e.target.value = "";
      return;
    }

    let limitedFiles = supported;
    if (currentFileCount + supported.length > MAX_ATTACHABLE_FILES) {
      const remaining = MAX_ATTACHABLE_FILES - currentFileCount;
      limitedFiles = supported.slice(0, remaining);
      showInfoToast(
        `Added ${remaining} file(s) (limit ${MAX_ATTACHABLE_FILES} files).`,
      );
    }

    // 1️⃣ Validate filenames (DO NOT HARD BLOCK)
    const validNameFiles = [];
    const invalidNameFiles = [];
    const normalize = (s) => s?.trim().toLowerCase();

    const extractDuplicateNames = (duplicates = []) =>
      duplicates.map((d) => normalize(d.originalname || d.filename));

    for (const file of limitedFiles) {
      const { valid, reason } = validateFileName(file.name);

      if (valid) {
        validNameFiles.push(file);
      } else {
        invalidNameFiles.push({ name: file.name, reason });
      }
    }

    if (invalidNameFiles.length > 0) {
      const count = invalidNameFiles.length;

      // 🧠 Adaptive timing
      const autoCloseTime = count <= 2 ? 2000 : count <= 4 ? 1600 : 1200;

      const gap = autoCloseTime + 150;

      invalidNameFiles.forEach((f, index) => {
        setTimeout(() => {
          showErrorToast(`${f.reason}${truncate(f.name)}`, {
            autoClose: autoCloseTime,
          });
        }, index * gap);
      });
    }

    if (validNameFiles.length === 0) {
      e.target.value = "";
      return;
    }

    // 2️⃣ Optimistically add files as "uploading"
    const getExt = (name) => name?.split(".").pop()?.toLowerCase();
    const isEmailExtractFile = (file) => {
      const ext = getExt(file?.name);
      return ext === "zip" || ext === "msg";
    };

    // Split: email-extract files (.zip/.msg) should NOT be uploaded to library
    const emailFiles = validNameFiles.filter(isEmailExtractFile);
    const libraryFiles = validNameFiles.filter((f) => !isEmailExtractFile(f));

    // Enforce: only one zip total (existing + newly selected)
    const existingZipCount = attachedFiles.filter(
      (f) => getExt(f?.file?.name) === "zip",
    ).length;
    const newZipFiles = emailFiles.filter((f) => getExt(f?.name) === "zip");

    let emailFilesAllowed = emailFiles;
    if (existingZipCount > 0 && newZipFiles.length > 0) {
      showErrorToast("Only one .zip file is allowed.");
      emailFilesAllowed = emailFilesAllowed.filter(
        (f) => getExt(f?.name) !== "zip",
      );
    } else if (newZipFiles.length > 1) {
      showErrorToast("Only one .zip file is allowed.");
      const [firstZip] = newZipFiles;
      emailFilesAllowed = [
        ...emailFilesAllowed.filter((f) => getExt(f?.name) !== "zip"),
        firstZip,
      ];
    }

    const emailTempFiles = emailFilesAllowed.map((file) => ({
      file,
      status: "done",
      clientId: `${file.name}-${file.size}-${file.lastModified}`,
    }));

    const tempFiles = libraryFiles.map((file) => ({
      file,
      status: "pending", // ✅ Don't show spinner yet
      clientId: `${file.name}-${file.size}-${file.lastModified}`,
    }));

    setAttachedFiles((prev) => [...prev, ...emailTempFiles, ...tempFiles]);

    if (emailTempFiles.length > 0) {
      setInput("");
      const textarea = document.querySelector(".input-textarea");
      if (textarea) {
        textarea.style.height = "40px";
        textarea.style.overflowY = "hidden";
      }
    }

    if (libraryFiles.length === 0) {
      e.target.value = "";
      return;
    }

    const selectedNames = libraryFiles.map((f) => normalize(f.name));

    setUploadedDocNames((prev) => [...new Set([...prev, ...selectedNames])]);

    // Store files temporarily. Do NOT upload yet.
    setPendingUploadFiles(libraryFiles);

    setUploadedInfo({
      count: libraryFiles.length,
      type: libraryFiles.length > 1 ? "files" : "file",
    });

    setShowUploadModal(true);

    e.target.value = "";
    return;
  };

  const handleUploadFiles = async () => {
    // if (!selectedFolder) {
    //   showErrorToast("Please select a folder.");
    //   return;
    // }

    setAttachedFiles((prev) =>
      prev.map((item) => ({
        ...item,
        status: item.status === "pending" ? "uploading" : item.status,
      })),
    );
    // ✅ Close the upload modal after successful upload
    setShowUploadModal(false);
    setSelectedFolder({
      id: null,
      name: "Root",
    });

    const formData = new FormData();

    pendingUploadFiles.forEach((file) => formData.append("files", file));

    formData.append("model", selectedModel);
    formData.append("mode", uploadMode.toLowerCase());
    formData.append("folder_id", selectedFolder.id);

    try {
      const token =
        localStorage.getItem("access_token") ||
        sessionStorage.getItem("access_token");

      const uploadEndpoint = `${process.env.REACT_APP_API_URL}/uploaded-files/newUploadv2`;

      // 4️⃣ Upload files
      const res = await api.post(uploadEndpoint, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // ✅ NEW BACKEND CONTRACT
      const { toasts = [] } = res.data;

      // Capture document_id mappings (best-effort; backward compatible)
      try {
        const nextIds = {};

        const normalize = (s) => s?.trim().toLowerCase();

        const filesSuccess =
          res.data?.fastapi_response?.files_success ||
          res.data?.fastapi_response?.files ||
          [];
        if (Array.isArray(filesSuccess)) {
          filesSuccess.forEach((row) => {
            const key = normalize(
              row?.file || row?.filename || row?.original_filename,
            );
            const docId = row?.document_id || row?.documentId;
            if (key && docId) nextIds[key] = String(docId);
          });
        }

        const processedFiles = res.data?.files || [];
        if (Array.isArray(processedFiles)) {
          processedFiles.forEach((row) => {
            const key = normalize(row?.file?.originalname);
            const docId = row?.originalMeta?.document_id;
            if (key && docId) nextIds[key] = String(docId);
          });
        }

        if (Object.keys(nextIds).length > 0) {
          setUploadedDocumentIds((prev) => ({ ...(prev || {}), ...nextIds }));
        }
      } catch {}

      if (toasts.length > 0) {
        const count = toasts.length;

        // 🧠 Adaptive timing (same philosophy as filename validation)
        const autoCloseTime = count <= 2 ? 2200 : count <= 4 ? 1800 : 1400;

        const gap = autoCloseTime + 150;

        toasts.forEach((toast, index) => {
          setTimeout(() => {
            const options = {
              autoClose: autoCloseTime,
              toastId: `upload-${index}-${toast.message}`,
            };

            const message = formatToastMessage(toast.message);

            if (toast.type === "success") {
              showSuccessToast(message, options);
            } else if (toast.type === "warning") {
              (showSuccessToast || showErrorToast)(message, options);
            } else {
              showSuccessToast(message, options);
            }
          }, index * gap);
        });
      }
      const normalize = (s) => s?.trim().toLowerCase();

      // 2️⃣ Update UI statuses based on toast messages
      setAttachedFiles((prev) =>
        prev.map((f) => {
          const fileName = normalize(f.file.name);

          const success = toasts.find(
            (t) =>
              t.type === "success" &&
              t.message.toLowerCase().includes(f.file.name.toLowerCase()),
          );

          const duplicate = toasts.find(
            (t) =>
              t.message.toLowerCase().includes(f.file.name.toLowerCase()) &&
              (t.message.includes("already exists") ||
                t.message.includes("pending")),
          );

          const failed = toasts.find(
            (t) =>
              t.type === "error" &&
              t.message.toLowerCase().includes(f.file.name.toLowerCase()),
          );

          if (success) return { ...f, status: "done" };
          if (duplicate) return { ...f, status: "already_trained" };
          if (failed) return { ...f, status: "error" };

          return f;
        }),
      );
    } catch (error) {
      const status = error.response?.status;
      const backendMessage =
        error.response?.data?.message || error.response?.data?.error;

      console.error("Upload failed:", {
        status,
        backendMessage,
        error,
      });

      // 🟡 ONLY mark already_trained if backend explicitly says duplicate
      const isDuplicate =
        backendMessage &&
        backendMessage.toLowerCase().includes("already exists");

      // 🔴 BLOCKED BY BACKEND (Global library conflict)
      if (isDuplicate) {
        showSuccessToast(backendMessage);

        // 🚨 STOP SPINNER — mark uploading files as error
        setAttachedFiles((prev) =>
          prev.map((f) =>
            f.status === "uploading" ? { ...f, status: "already_trained" } : f,
          ),
        );
      } else {
        // 🔴 REAL UNKNOWN ERROR
        console.error("Upload failed:", error);

        showErrorToast(
          backendMessage || "Upload failed. Please try again later.",
        );

        setAttachedFiles((prev) =>
          prev.map((f) =>
            f.status === "uploading" ? { ...f, status: "error" } : f,
          ),
        );
      }
    }
  };

  useEffect(() => {
    if (showUploadModal) {
      fetchFoldersForMode(uploadMode);
    }
  }, [showUploadModal, uploadMode]);

  const buildTree = (items) => {
    const map = {};
    const roots = [];

    items.forEach((item) => {
      map[item.id] = {
        ...item,
        children: [],
      };
    });

    items.forEach((item) => {
      if (item.parentId && map[item.parentId]) {
        map[item.parentId].children.push(map[item.id]);
      } else {
        roots.push(map[item.id]);
      }
    });

    return roots;
  };

  const fetchFoldersForMode = async (mode) => {
    const token = localStorage.getItem("access_token");

    const response = await api.get(
      `${process.env.REACT_APP_API_URL}/trained-documents/get-trained-docs`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    const folders = response.data.filter(
      (item) => item.itemType === "folder" && item.mode === mode.toLowerCase(),
    );

    setFolderItems(buildTree(folders));
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const files = Array.from(e.dataTransfer.files);
    if (!files.length) return;

    // Reuse existing logic
    handleFileChange({ target: { files } });
  };

  const handleCancel = () => {
    setErrorModal({ show: false, message: "" });
    setAttachedFiles([]); // clear files
  };

  // 🔹 Redirect & close modal
  const handleOk = () => {
    setErrorModal({ show: false, message: "" });
    dispatch(togglePrivacyMode());

    // Navigate to new page without hard reload
    navigate("/user/new");
    handleMenuClick("New Chat");
    navigate(0);

    showSuccessToast(
      isFullPrivacy
        ? TOAST_MESSAGES.PRIVACY_MODE_OFF
        : TOAST_MESSAGES.PRIVACY_MODE_ON,
    );
  };

  // Remove a specific file by index

  const removeAttachedFile = (clientId) => {
    setAttachedFiles((prev) => {
      const fileToRemove = prev.find(
        (item) => item.clientId === clientId,
      )?.file;

      const removedName = fileToRemove?.name?.trim().toLowerCase();

      // 🔹 keep uploadedDocNames in sync
      if (removedName) {
        setUploadedDocNames((docs) =>
          docs.filter((name) => name !== removedName),
        );
        setUploadedDocumentIds((prevIds) => {
          const next = { ...(prevIds || {}) };
          delete next[removedName];
          return next;
        });
      }

      // 🔹 remove from UI list
      return prev.filter((item) => item.clientId !== clientId);
    });
  };

  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");

  useEffect(() => {
    const storedUser =
      JSON.parse(localStorage.getItem("user")) ||
      JSON.parse(sessionStorage.getItem("user"));

    const fetchProfile = async () => {
      const token =
        localStorage.getItem("access_token") ||
        sessionStorage.getItem("access_token");

      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/user-profile/profile`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        if (!res.ok) throw new Error("Failed to fetch profile");

        const data = await res.json();

        // ✅ Set Username
        setUserName(data.user_name || "User");

        // ✅ Fix slashes → Build complete URL
        const fixedPath = data.user_profile_pic?.replace(/\\/g, "/");
        const finalPicUrl = fixedPath
          ? `${process.env.REACT_APP_SERVER_URL}/${fixedPath}`
          : `${process.env.REACT_APP_SERVER_URL}/uploads/default_img.png`;


        setProfilePicUrl(finalPicUrl);
      } catch (err) {
        console.error("Profile fetch failed:", err);
      }
    };

    fetchProfile();
    setUploadedDocNames([]);

    //  Disclaimer check
    if (!storedUser.termsAccepted) {
      setShowDisclaimer(true);
      // setShowAccessMode(true);
      return;
    }
  }, [token]);

  // useEffect(() => {
  //   const storedUser =
  //     JSON.parse(localStorage.getItem("user")) ||
  //     JSON.parse(sessionStorage.getItem("user"));

  //   if (storedUser) {
  //     // Username
  //     if (storedUser.user_name) {
  //       setUserName(storedUser.user_name);
  //     }

  //     // Profile Image (Full URL)
  //     if (storedUser.user_profile_pic) {
  //       const url = `${process.env.REACT_APP_API_URL}/${storedUser.user_profile_pic}`;
  //       setProfilePicUrl(url);
  //     }

  //     // Disclaimer check
  //     if (!storedUser.termsAccepted) {
  //       setShowDisclaimer(true);
  //       setShowAccessMode(true);
  //     }
  //   }
  // }, []);

  useEffect(() => {
    if (location.state?.sessionId) {
      setSessionId(location.state.sessionId);
      setStartChat(true);
      dispatch(setIsChatPage(true)); // <-- set chat page true
    } else {
      setSessionId(null);
      setStartChat(false);
      dispatch(setIsChatPage(false)); // <-- set chat page false
    }
  }, [location.state]);

  const handleDisclaimerAccept = async () => {
    const user = JSON.parse(
      localStorage.getItem("user") || sessionStorage.getItem("user"),
    );

    try {
      await api.post(
        `${process.env.REACT_APP_API_URL}/users/accept-terms`,
        { accepted: true },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const updatedUser = { ...user, termsAccepted: true };
      if (localStorage.getItem("user")) {
        localStorage.setItem("user", JSON.stringify(updatedUser));
      } else {
        sessionStorage.setItem("user", JSON.stringify(updatedUser));
      }

      setShowDisclaimer(false); // ✅ Hide popup
      // setShowAccessMode(true);
      showSuccessToast("Terms accepted successfully.");
    } catch (error) {
      console.error("❌ Failed to accept disclaimer", error);
      showErrorToast("Failed to accept terms. Please try again.");
    }
  };

  // Derived state: true if any file is uploading
  const isUploading = attachedFiles.some((f) => f.status === "uploading");

  const handleSend = () => {
    if (!input.trim() && attachedFiles.length === 0) return;

    // Prepare message
    let messageToSend = input.trim();
    if (attachedFiles.length > 0) {
      const fileNames = attachedFiles.map((f) => f.file.name).join(", ");
      messageToSend += messageToSend
        ? ` (Attached files: ${fileNames})`
        : `(Attached files: ${fileNames})`;
    }

    // Capture a copy of files BEFORE clearing state
    const filesToSend = [...attachedFiles]; // ✅

    // Navigate to chat page
    setUserMessage(input.trim());
    setStartChat(true);
    // setSessionId(null);
    dispatch(setIsChatPage(true));

    // Clear input and attached files
    setInput("");
    setAttachedFiles([]);
    setFilesUploaded(false);

    // Pass filesToSend as prop
    setFilesToSendForChat(filesToSend); // use separate state to pass to ChatPage
  };

  // ✅ Default prompts to display instantly before backend fetch
  const defaultPrompts = [
    { prompt: "Today’s US market news", icon: "bi-graph-up-arrow" }, // Market & finance
    { prompt: "Ancient civilizations impact", icon: "bi-bank" }, // History / civilizations
    { prompt: "Top LLMs this month", icon: "bi-stars" }, // AI / trending models
    { prompt: "Python coding help", icon: "bi-code-slash" }, // Coding / development
  ];

  // Set initial default prompts
  useEffect(() => {
    setPrompts(defaultPrompts);
    setUploadedDocNames([]);
  }, []);

  // ✅ Handle screen resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 575);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ Fetch prompts from backend
  const fetchPrompts = async () => {
    try {
      setLoading(true);

      const token =
        localStorage.getItem("access_token") ||
        sessionStorage.getItem("access_token");

      const res = await api.get(
        `${process.env.REACT_APP_API_URL}/chat/generate`,
        {
          headers: { Authorization: `Bearer ${token}` },
          silent: true, // ✅ prevents global error toast
        },
      );

      if (res.data?.status === "success" && Array.isArray(res.data.prompts)) {
        setPrompts(res.data.prompts);
      } else {
        console.warn("⚠️ Using default prompts due to invalid API response");
        setPrompts(defaultPrompts);
      }
    } catch (err) {
      console.error("❌ Error fetching prompts:", err.message);
      // Keep default prompts on API failure
      setPrompts(defaultPrompts);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrompts();
  }, [refreshToggle]);

  // ✅ Handle refresh button (smooth fade animation)
  const handleRefresh = () => {
    setFade(true);
    setTimeout(() => {
      setRefreshToggle((prev) => !prev);
      setFade(false);
    }, 300);
  };

  // const cardData = refreshToggle ? cardSetTwo : cardSetOne;


  // local temp state
  // local temp state
  const [localPrefs, setLocalPrefs] = useState(aiPreferences);

  useEffect(() => {
    if (showResponsesModal) {
      setLocalPrefs(aiPreferences);
    }
  }, [showResponsesModal, aiPreferences]);

  useEffect(() => {
    if (!showResponsesModal) {
      setShowInfoTooltip(false);
    }
  }, [showResponsesModal]);

  const handleChange = (key, value) => {
    setLocalPrefs((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleApply = () => {
    setAiPreferences(localPrefs);
    setShowResponsesModal(false);
  };

  const handleCancel1 = () => {
    setLocalPrefs(aiPreferences);
    setShowResponsesModal(false);
  };

  useEffect(() => {
    const close = (e) => {
      if (
        !e.target.closest(".custom-popover") &&
        !e.target.closest(".icon-image")
      ) {
        setShowResponsesModal(false);
      }
    };

    document.addEventListener("click", close, true);
    return () => document.removeEventListener("click", close, true);
  }, []);

  const LENGTH_OPTIONS = [
    { value: "long", label: "Longest (Default)" },
    { value: "deep", label: "Deep Analysis" },
    { value: "medium", label: "Medium" },
  ];

  const AI_ROLE_OPTIONS = [
    { value: "default", label: "General Assistant (Default)" },
    { value: "Brainstorm partner", label: "Brainstorm partner" },
    { value: "Career coach", label: "Career coach" },
    { value: "Chef", label: "Chef" },
    { value: "Coding coach", label: "Coding coach" },
    { value: "Editor", label: "Editor" },
    { value: "Entertainment guide", label: "Entertainment guide" },
    { value: "Fitness trainer", label: "Fitness trainer" },
    { value: "Gardener", label: "Gardener" },
    { value: "Homework helper", label: "Homework helper" },
    { value: "Language tutor", label: "Language tutor" },
    { value: "Life coach", label: "Life coach" },
    { value: "Marketer", label: "Marketer" },
    { value: "Editor", label: "Editor" },
    { value: "Product manager", label: "Product manager" },
    { value: "Public speaking coach", label: "Public speaking coach" },
    { value: "Social media copywriter", label: "Social media copywriter" },
    { value: "Storyteller", label: "Storyteller" },
    { value: "Tech support specialist", label: "Tech support specialist" },
    { value: "Teacher", label: "Teacher" },
    { value: "Translator", label: "Translator" },
    { value: "Travel guide", label: "Travel guide" },
    { value: "Trivia expert", label: "Trivia expert" },
    { value: "Writer", label: "Writer" },
  ];

  const USER_ROLE_OPTIONS = [
    { value: "default", label: "Universal (Default)" },
    { value: "Parent", label: "Parent" },
    { value: "Professional", label: "Professional" },
    { value: "Programmer", label: "Programmer" },
    { value: "Student", label: "Student" },
    { value: "Writer", label: "Writer" },
  ];

  const TONE_MODE_MAP = [
    { value: "default", label: "Neutral (Default)" },
    { value: "eli5", label: "Simple" },
    { value: "tldr", label: "Summary" },
    { value: "jargonize", label: "Professional" },
    { value: "humanize", label: "Naturally" },
    { value: "feynman", label: "Deep" },
  ];

  const DEEP_ANALYSIS_MAP = [
    { value: "deep", label: "Deep Analysis (Default)" },
    { value: "quick", label: "Quick" },
    { value: "balanced", label: "Standard" },
  ];

  const retryUpload = async (item) => {
    // Show spinner only for the selected file
    setAttachedFiles((prev) =>
      prev.map((f) =>
        f.clientId === item.clientId ? { ...f, status: "uploading" } : f,
      ),
    );

    const formData = new FormData();
    formData.append("files", item.file);
    formData.append("model", selectedModel);
    formData.append("mode", uploadMode.toLowerCase());
    formData.append("folder_id", selectedFolder.id);

    try {
      const token =
        localStorage.getItem("access_token") ||
        sessionStorage.getItem("access_token");

      const uploadEndpoint = `${process.env.REACT_APP_API_URL}/uploaded-files/newUploadv2`;

      const res = await api.post(uploadEndpoint, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const { toasts = [] } = res.data;

      // Show backend toasts
      toasts.forEach((toast) => {
        const message = formatToastMessage(toast.message);

        if (toast.type === "success") {
          showSuccessToast(message);
        } else if (toast.type === "warning") {
          showInfoToast(message);
        } else {
          showErrorToast(message);
        }
      });

      // Update only the retried file
      setAttachedFiles((prev) =>
        prev.map((f) => {
          if (f.clientId !== item.clientId) return f;

          const success = toasts.find(
            (t) =>
              t.type === "success" &&
              t.message.toLowerCase().includes(f.file.name.toLowerCase()),
          );

          const duplicate = toasts.find(
            (t) =>
              t.message.toLowerCase().includes(f.file.name.toLowerCase()) &&
              (t.message.toLowerCase().includes("already exists") ||
                t.message.toLowerCase().includes("pending")),
          );

          const failed = toasts.find(
            (t) =>
              t.type === "error" &&
              t.message.toLowerCase().includes(f.file.name.toLowerCase()),
          );

          if (success) return { ...f, status: "done" };
          if (duplicate) return { ...f, status: "already_trained" };
          if (failed) return { ...f, status: "error" };

          return f;
        }),
      );
    } catch (error) {
      const backendMessage =
        error.response?.data?.message || error.response?.data?.error;

      showErrorToast(backendMessage || "Retry failed. Please try again later.");

      setAttachedFiles((prev) =>
        prev.map((f) =>
          f.clientId === item.clientId ? { ...f, status: "error" } : f,
        ),
      );
    }
  };

  return (
    <div className="px-3 h-100 d-flex justify-content-center">
      {showAccessMode && (
        <AccessModePopup setShowAccessMode={setShowAccessMode} />
      )}
      {showDisclaimer && <DisclaimerPopup onAccept={handleDisclaimerAccept} />}
      {!startChat ? (
        <div className="home w-100 d-flex flex-column justify-content-between">
          {/* Main content section - Heading, Paragraph, Cards */}
          <div className="flex-grow-1 d-flex flex-column  align-items-center justify-content-center text-center main-content">
            <div className="w-100">
              <h1 className="text-center mb-3">
                Hello {userName?.charAt(0).toUpperCase() + userName?.slice(1)},
              </h1>

              <h1 className="text-center mb-3 title">
                How can I help you today?
              </h1>
            </div>

            <p className="home_desc mb-3">
              Start your chat with VelaKoda: pick a prompt or ask anything you
              want.
            </p>

            {/* <div
              className={`row fade-container ${fade ? "fade-out" : "fade-in"}`}
            >
              {prompts.map((card, index) => (
                <div className="col-md-6 col-lg-3 mb-4 prompt-card" key={index}>
                  <div
                    className="card home-card rounded-4 shadow-sm p-3 position-relative"
                    onClick={() => {
                      setUserMessage(card.prompt);
                      setStartChat(true);
                      setSessionId(null);
                      dispatch(setIsChatPage(true));
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <div
                      className="d-flex prompt-text align-items-start justify-content-beteween"
                      style={{ minHeight: "85px" }}
                    >
                      <i className={`bi ${card.icon} fs-4 me-2 mt-1 `}></i>
                      <p className="ms-2 fw-normal">{card.prompt}</p>
                    </div>
                    <div className="position-absolute bottom-0 end-0 m-2">
                      <i className="bi bi-arrow-right-circle fs-4"></i>
                    </div>
                  </div>

                 
                  {index === 0 && (
                    <div
                      className="d-none d-sm-flex align-items-center mt-1 ms-1 refresh-prompts"
                      onClick={handleRefresh}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="bi bi-arrow-clockwise me-2"></i>
                      {loading ? "Refreshing..." : "Refresh Prompts"}
                    </div>
                  )}
                </div>
              ))}
            </div> */}

            <div className={`fade-container ${fade ? "fade-out" : "fade-in"}`}>
              <div className="prompt-wrapper">
                {prompts.map((card, index) => (
                  <div
                    key={index}
                    className="prompt-pill"
                    onClick={() => {
                      setUserMessage(card.prompt);
                      setStartChat(true);
                      setSessionId(null);
                      dispatch(setIsChatPage(true));
                    }}
                  >
                    <i className={`bi ${card.icon} me-2`}></i>
                    <span>{card.prompt}</span>
                  </div>
                ))}
                <div
                  className="refresh-prompts2  align-items-center d-flex justify-content-start"
                  style={{ cursor: "pointer", color: "var(--dark-color)" }}
                  onClick={handleRefresh}
                  title="Refresh-prompts"
                >
                  <i className="bi bi-arrow-clockwise me-2 refresh-prompts2"></i>
                  {/* {loading ? "Refreshing..." : "Refresh prompts"} */}
                </div>
              </div>

              {/* <div
                className="refresh-prompts mt-4 d-flex justify-content-start"
                onClick={handleRefresh}
              >
                <i className="bi bi-arrow-clockwise me-2"></i>
                {loading ? "Refreshing..." : "Refresh prompts"}
              </div> */}
            </div>

            {/* ✅ Mobile refresh button */}
            <div
              className="d-flex d-sm-none mt-4 refresh-prompts1 gap-1 justify-content-center align-items-center"
              onClick={handleRefresh}
              style={{ cursor: "pointer" }}
            >
              <img src={refreshIcon} className="icon-image" alt="Close" />
              {loading ? "Refreshing..." : "Refresh Prompts"}
            </div>
          </div>

          {/* Input area section */}
          <div className="">
            <div
              className="rounded p-1 mt-1 input-area"
              style={{ border: "1px solid var(--dark-color)" }}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
            >
              {/* File input (hidden) */}
              <input
                type="file"
                multiple
                accept=".pdf,.docx,.txt,.doc,.pptx,.xlsx,.zip,.msg,.mp3,.wav,.aac,.flac,.mp4,.mov,.avi,.mkv,.flv,.png,.jpg,.jpeg,.gif,.bmp,.tiff"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />

              {/* Attached files preview */}
              {attachedFiles.length > 0 && (
                <div className="d-flex flex-wrap mb-2">
                  {attachedFiles.map((item, idx) => (
                    <div
                      // key={idx}
                      key={item.clientId}
                      className="attached-file-chip position-relative  me-2 mt-1 rounded bg-light d-flex flex-column px-2 py-1"
                      style={{
                        maxWidth: "200px",
                        overflow: "visible",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                      }}
                    >
                      {/* Content */}
                      <div
                        className="d-flex align-items-center gap-1"
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          maxWidth: "100%",
                        }}
                      >
                        <img src={fileIcon} alt="PDF" width="18" />
                        <span
                          style={{
                            fontSize: "small",
                            display: "inline-block",
                            maxWidth: "170px", // adjust as needed
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            verticalAlign: "middle",
                          }}
                          title={item.file.name} // shows full name on hover
                        >
                          {item.file.name}
                        </span>
                      </div>

                      <small style={{ fontSize: "10px", color: "#555" }}>
                        {(item.file.size / (1024 * 1024)).toFixed(2)} MB
                      </small>

                      {item.status === "done" && (
                        <small style={{ fontSize: "10px", color: "green" }}>
                          Uploaded ✅
                        </small>
                      )}
                      {item.status === "error" && (
                        <div
                          className="d-flex justify-content-between align-items-center w-100"
                          style={{ fontSize: "10px", color: "red" }}
                        >
                          <span>Failed ❌</span>

                          <button
                            type="button"
                            className="cancle-btn p-1 ak-text-sm"
                            style={{
                              fontSize: "10px",
                              border: "none",
                              cursor: "pointer",
                            }}
                            onClick={() => retryUpload(item)}
                          >
                            Retry
                          </button>
                        </div>
                      )}
                      {item.status === "already_trained" && (
                        <small style={{ fontSize: "10px", color: "green" }}>
                          Uploaded ✅{/* Training Completed ✅ */}
                        </small>
                      )}

                      {/* Delete (cross) button - stays on top always */}
                      <img
                        src={crossIcon}
                        alt="Remove"
                        // onClick={() => removeAttachedFile(idx)}
                        onClick={() => removeAttachedFile(item.clientId)}
                        style={{
                          position: "absolute",
                          top: "-2px",
                          right: "-6px",
                          width: "14px",
                          height: "14px",
                          // cursor:
                          //   item.status === "uploading"
                          //     ? "not-allowed"
                          //     : "pointer",
                          // opacity: item.status === "uploading" ? 0.5 : 1,
                          zIndex: 1003, // 👈 keep above overlay
                        }}
                      />

                      {/* Overlay Spinner */}
                      {item.status === "uploading" && (
                        <div
                          style={{
                            position: "absolute",
                            inset: 0,
                            background: "rgba(255, 255, 255, 0.6)", // transparent white
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "inherit",
                            zIndex: 2, // 👈 below the cross button
                          }}
                        >
                          <div
                            className="spinner-border"
                            role="status"
                            style={{
                              width: "20px",
                              height: "20px",
                              color: "black", // 👈 spinner in black
                            }}
                          />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {/* Textarea + buttons */}
              <div>
                <textarea
                  type="text"
                  className="p-2 border-0 shadow-none input-textarea "
                  placeholder={
                    hasEmailExtractFiles
                      ? "Attachments received for email extraction. You can add more files. Text input is disabled."
                      : isFocused
                        ? ""
                        : branding(
                            "Welcome back to VelaKoda! How can I assist you?",
                          )
                  }
                  value={input}
                  disabled={hasEmailExtractFiles}
                  readOnly={hasEmailExtractFiles}
                  onChange={(e) => {
                    if (hasEmailExtractFiles) return;
                    setInput(e.target.value);
                    // Auto expand textarea height
                    e.target.style.height = "auto";
                    e.target.style.height = e.target.scrollHeight + "px";
                    // ✅ फक्त text खूप झाल्यावर scroll दाखव
                    if (e.target.scrollHeight > 200) {
                      e.target.style.overflowY = "auto";
                    } else {
                      e.target.style.overflowY = "hidden";
                    }
                  }}
                  onFocus={() => setIsFocused(true)}
                  onBlur={() => setIsFocused(false)}
                  onKeyDown={(e) => {
                    if (hasEmailExtractFiles) {
                      e.preventDefault();
                      return;
                    }
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      handleSend();
                      // reset textarea height
                      e.target.style.height = "40px";
                      e.target.style.overflowY = "hidden"; // reset scroll लपवा
                      e.target.style.height = "auto";
                    }
                  }}
                />
              </div>

              <div className="d-flex align-items-center justify-content-between p-1 rounded-3">
                <div className="d-flex gap-2">
                  {/* Customize Responses */}
                  <div className="position-relative">
                    <button
                      className="btn p-0 chat-btn-message mb-1"
                      title="Customize Responses"
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowResponsesModal((prev) => !prev);
                      }}
                    >
                      <i className="bi bi-sliders fs-6"></i>
                    </button>

                    {showResponsesModal && (
                      <div
                        className="custom-popover ak-text-sm"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="popover-content">
                          <div className="fw-bold mb-2  ak-text-md">
                            Customize Responses
                            <span
                              className="info-icon"
                              title="Click for response option details"
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowInfoTooltip((prev) => !prev);
                              }}
                              style={{
                                cursor: "pointer",
                                fontSize: "0.85em",
                                marginLeft: "6px",
                                color: "#0d6efd",
                              }}
                            >
                              (i)
                            </span>
                          </div>
                          {showInfoTooltip && (
                            <div
                              className="ak-text-xs mb-2"
                              style={{
                                color: "#000000",
                                fontWeight: 600,
                                fontSize: "0.95em",
                                lineHeight: 1.4,
                                padding: "10px 12px",
                                borderRadius: "8px",
                                background: "rgba(13, 110, 253, 0.06)",
                                border: "1px solid rgba(13, 110, 253, 0.18)",
                              }}
                            >
                              Tone/Style changes how the answer sounds. Length
                              of Responses adjusts verbosity. AI Role sets the
                              assistant persona. Your Role gives context for
                              better responses.
                            </div>
                          )}

                          <div className="settings-body">
                            {/* Tool Mode */}
                            <div className="settings-row">
                              <span className="refresh-prompts ak-text-sm">
                                Tone / Style
                              </span>
                              <select
                                value={localPrefs.tone}
                                onChange={(e) =>
                                  handleChange("tone", e.target.value)
                                }
                              >
                                {TONE_MODE_MAP.map((tone) => (
                                  <option key={tone.value} value={tone.value}>
                                    {tone.label}
                                  </option>
                                ))}
                              </select>
                            </div>

                            {/* Analysis */}
                            {/* <div className="settings-row">
                              <span className="refresh-prompts ak-text-sm">
                                Analysis
                              </span>
                              <select
                                value={localPrefs.length}
                                onChange={(e) =>
                                  handleChange("analysis", e.target.value)
                                }
                              >
                                {DEEP_ANALYSIS_MAP.map((length) => (
                                  <option
                                    key={length.value}
                                    value={length.value}
                                  >
                                    {length.label}
                                  </option>
                                ))}
                              </select>
                            </div> */}

                            {/* Length */}
                            <div className="settings-row">
                              <span className="refresh-prompts ak-text-sm">
                                Length of Responses
                              </span>
                              <select
                                value={localPrefs.length}
                                onChange={(e) =>
                                  handleChange("length", e.target.value)
                                }
                              >
                                {LENGTH_OPTIONS.map((length) => (
                                  <option
                                    key={length.value}
                                    value={length.value}
                                  >
                                    {length.label}
                                  </option>
                                ))}
                              </select>
                            </div>

                            {/* AI Role */}
                            <div className="settings-row">
                              <span className="refresh-prompts ak-text-sm">
                                AI Role
                              </span>
                              <select
                                value={localPrefs.aiRole}
                                onChange={(e) =>
                                  handleChange("aiRole", e.target.value)
                                }
                              >
                                {AI_ROLE_OPTIONS.map((role) => (
                                  <option key={role.value} value={role.value}>
                                    {role.label}
                                  </option>
                                ))}
                              </select>
                            </div>

                            {/* User Role */}
                            <div className="settings-row">
                              <span className="refresh-prompts ak-text-sm">
                                Your Role
                              </span>
                              <select
                                value={localPrefs.userRole}
                                onChange={(e) =>
                                  handleChange("userRole", e.target.value)
                                }
                              >
                                {USER_ROLE_OPTIONS.map((role) => (
                                  <option key={role.value} value={role.value}>
                                    {role.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div className="d-flex gap-2 justify-content-center mt-2 align-items-center">
                            <button
                              className="cancle-btn w-25 ak-text-sm py-1"
                              title="Cancel"
                              onClick={handleCancel1}
                            >
                              Cancel
                            </button>
                            <button
                              className="custom-btn w-25 ak-text-sm py-1"
                              title="Apply"
                              onClick={handleApply}
                            >
                              Apply
                            </button>
                            <span
                              className="reset-icon"
                              title="Reset to default"
                              onClick={() => {
                                // resetAiPreferences(); //apply direct reseet
                                setLocalPrefs(DEFAULT_AI_PREFERENCES);
                                // setShowResponsesModal(false);
                              }}
                            >
                              <img
                                src={reloadIcon}
                                className="icon-image pointer"
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <button
                    className=" btn p-0 chat-btn-message"
                    title="Attach Files"
                    onClick={handleAttachClick}
                  >
                    <i className="bi bi-paperclip fs-5"></i>
                    {/* <span className="pill-label">Attach</span> */}
                  </button>

                  {/* <button
                    className={`btn-link p-0 pill-chat-btn-message ${
                      isSearchActive ? "active" : ""
                    }`}
                    title="Search"
                    onClick={() => setIsSearchActive((prev) => !prev)}
                  >
                    <i className="bi bi-globe fs-6 px-1"></i>
                    <span className="pill-label">Search</span>
                  </button> */}

                  {/* Read Aloud */}
                  <button
                    className=" btn p-0 chat-btn-message"
                    onClick={toggleReadAloud}
                    title="Reader"
                  >
                    <i
                      className={`bi ${
                        isSpeaking ? "bi-volume-mute" : "bi-volume-up"
                      } fs-5`}
                    ></i>
                  </button>

                  {/* Mic */}
                  <button
                    className=" btn p-0 chat-btn-message"
                    onClick={() => {
                      setMicOpen(true);
                      startRecording();
                    }}
                    title="Audio"
                  >
                    <i className="bi bi-mic fs-5"></i>
                    {/* <span className="pill-label">Audio</span> */}
                  </button>

                  {/* Mic Overlay */}
                  {micOpen && (
                    <div className="mic-overlay position-absolute start-50 translate-middle-x p-3">
                      {/* Waveform */}
                      <div className="mic-waveform d-flex gap-2 mb-2">
                        {[...Array(5)].map((_, i) => (
                          <span key={i} className="wave-dot"></span>
                        ))}
                      </div>

                      {/* Live preview */}
                      <div
                        className="live-preview mb-2 p-2 rounded"
                        style={{
                          background: "#f8f9fa",
                          height: "40px",
                          fontSize: "12px",
                          overflowY: "auto",
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        {isRecording
                          ? "Listening..."
                          : isProcessingSTT
                            ? "Processing..."
                            : interimTranscript}
                      </div>

                      {/* Buttons */}
                      <div className="d-flex gap-2">
                        <button
                          className="btn btn-sm d-flex align-items-center justify-content-center"
                          onClick={stopRecording}
                          disabled={isProcessingSTT}
                          title="Confirm"
                          style={{
                            color: "var(--btn-color)",
                            backgroundColor: "var(--primary-color)",
                            minWidth: "36px",
                            opacity: isProcessingSTT ? 0.7 : 1,
                          }}
                        >
                          {isProcessingSTT ? (
                            <span
                              className="spinner-border spinner-border-sm text-light"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            <i className="bi bi-check-lg" />
                          )}
                        </button>

                        <button
                          className="btn btn-sm border"
                          onClick={cancelRecording}
                          disabled={isProcessingSTT}
                          title="Cancel"
                          style={{
                            color: "var(--primary-color)",
                            backgroundColor: "var(--btn-color)",
                            opacity: isProcessingSTT ? 0.6 : 1,
                          }}
                        >
                          <i className="bi bi-x-lg" />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                <button
                  className="custom-send-btn m-0 p-0 d-flex align-items-center justify-content-center"
                  onClick={handleSend}
                  disabled={isUploading} // disable while uploading
                  style={{
                    opacity: isUploading ? 0.5 : 1,
                    cursor: isUploading ? "not-allowed" : "pointer",
                  }}
                >
                  <img
                    src={send}
                    alt="Send"
                    title="Send"
                    style={{
                      width: "30px",
                      height: "30px",
                    }}
                  />
                </button>
              </div>
            </div>
            <span className="claimer-text d-flex align-items-center justify-content-center w-100 text-center px-0 px-md-3 py-0 py-md-1">
              VelaKoda may display inaccurate information or can make mistakes.
            </span>
          </div>

          {/* ✅ Custom Error Modal */}
          {errorModal.show && (
            <div className="modal modal-backdrop-custom d-block" tabIndex="-1">
              <div className="modal-dialog-centered">
                <div className="modal-content   mx-auto">
                  <div className="modal-header border-bottom justify-content-center position-relative">
                    <h5 className="modal-title m-0 ">File Size Alert</h5>
                    <button
                      type="button"
                      className="modal-close-btn"
                      aria-label="Close"
                      onClick={handleCancel}
                    >
                      <img src={crossIcon} className="icon-image" alt="Close" />
                    </button>
                  </div>
                  {/* <hr /> */}
                  <div className="modal-body text-center">
                    <p
                      dangerouslySetInnerHTML={{ __html: errorModal.message }}
                      className="fw-normal"
                      style={{ lineHeight: "1.6", fontSize: "15px" }}
                    ></p>
                  </div>

                  <div className="d-flex justify-content-center mb-3 gap-3">
                    <button
                      type="button"
                      className="w-25 cancle-btn"
                      onClick={handleCancel}
                    >
                      No
                    </button>
                    <button
                      type="button"
                      className=" w-25 custom-btn "
                      onClick={handleOk}
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          <UploadDocumentModal
            show={showUploadModal}
            onClose={() => {
              setShowUploadModal(false);
              setAttachedFiles([]);
            }}
            uploadMode={uploadMode}
            setUploadMode={setUploadMode}
            uploadedInfo={uploadedInfo}
            folderItems={folderItems}
            selectedFolder={selectedFolder}
            setSelectedFolder={setSelectedFolder}
            onSubmit={handleUploadFiles}
          />
        </div>
      ) : (
        <ChatPage
          firstMessage={userMessage}
          attachedFilesFromHome={filesToSendForChat}
          // sessionId={sessionId}
          selectedMode={selectedMode}
          profilePic={profilePicUrl} // 👈 profile pic
          userName={userName} // 👈 user name
          isSearchActive={isSearchActive}
          isKnowledgeSearchActive={isKnowledgeSearchActive}
        />
      )}
    </div>
  );
}

export default Home;
